// extracted by mini-css-extract-plugin
export var billingAddress = "_y4-g";
export var contactInfo = "_y4-d";
export var customerInfoContainer = "_y4-c";
export var customerInfoContainerMobile = "_y4-h";
export var customerInfoRow = "_y4-a";
export var customerInfoSection = "_y4-b";
export var fullWidthDividerMobile = "_y4-i";
export var imageContainer = "_y4-1";
export var paymentMethod = "_y4-e";
export var priceText = "_y4-6";
export var priceTextMobile = "_y4-7";
export var product = "_y4-0";
export var productImage = "_y4-2";
export var productInfo = "_y4-4";
export var productMobile = "_y4-9";
export var productTitle = "_y4-8";
export var quantityBadge = "_y4-3";
export var quantityText = "_y4-5";
export var shippingAddress = "_y4-f";